module.exports = __webpack_public_path__ + "img/golden-pharma.ea5f1c78.png";